<button
  class="customize-columns-trigger"
  [class.customize-columns-trigger-active]="isOpen"
  (click)="openPanel()"
  id="customize-columns-trigger"
  data-testid="customize-columns-trigger"
  nz-tooltip
  nzTooltipTitle="Customize columns"
  type="button"
>
  <i nz-icon nzType="layout" nzTheme="outline"></i>
</button>

<nz-drawer
  [nzVisible]="isOpen"
  [nzWidth]="320"
  [nzClosable]="false"
  [nzMaskClosable]="true"
  [nzBodyStyle]="{ padding: '0', display: 'flex', 'flex-direction': 'column', overflow: 'hidden' }"
  (nzOnClose)="cancel()"
>
  <ng-container *nzDrawerContent>
    <div class="customize-columns-header">
      <div>
        <div class="customize-columns-title">Columns</div>
        <div class="customize-columns-subtitle" data-testid="customize-columns-count">
          {{ selectedCount }} of {{ totalCount }} selected
        </div>
      </div>
      <button
        class="customize-columns-close-btn"
        (click)="cancel()"
        id="customize-columns-close"
        data-testid="customize-columns-close"
        type="button"
      >
        <i nz-icon nzType="close" nzTheme="outline"></i>
      </button>
    </div>

    <div class="customize-columns-search">
      <nz-input-group [nzPrefix]="searchPrefix">
        <input
          nz-input
          [ngModel]="search"
          (ngModelChange)="onSearchChange($event)"
          placeholder="Search columns"
          id="customize-columns-search"
          data-testid="customize-columns-search"
        />
      </nz-input-group>
      <ng-template #searchPrefix>
        <i nz-icon nzType="search" nzTheme="outline"></i>
      </ng-template>
    </div>

    <div class="customize-columns-divider"></div>

    <div class="customize-columns-groups">
      <div
        *ngFor="let group of groups; trackBy: trackByGroupKey"
        class="customize-columns-group"
        [attr.data-testid]="'customize-columns-group-' + group.key"
      >
        <div
          class="customize-columns-group-header"
          (click)="toggleGroup(group.key)"
        >
          <div class="customize-columns-group-header-left">
            <i
              nz-icon
              nzType="right"
              nzTheme="outline"
              class="customize-columns-chevron"
              [class.customize-columns-chevron-expanded]="!collapsed[group.key]"
            ></i>
            <span class="customize-columns-group-label">{{ group.label }}</span>
            <span class="customize-columns-group-badge">{{ group.badge }}</span>
          </div>
          <button
            class="customize-columns-toggle-all-btn"
            (click)="toggleAllInGroup(group.key, $event)"
            [attr.data-testid]="'customize-columns-toggle-all-' + group.key"
            type="button"
          >
            {{ group.allSelected ? 'Deselect all' : 'Select all' }}
          </button>
        </div>

        <ng-container *ngIf="!collapsed[group.key]">
          <label
            *ngFor="let col of group.columns; trackBy: trackByColumnId"
            nz-checkbox
            class="customize-columns-col-row"
            [nzChecked]="!col.isHidden"
            (nzCheckedChange)="toggleColumn(col.id)"
            [attr.data-testid]="'customize-columns-col-' + col.id"
          >
            <span
              class="customize-columns-col-label"
              [class.customize-columns-col-label-visible]="!col.isHidden"
            >{{ col.displayName }}</span>
          </label>

          <div *ngIf="group.hasNoResults" class="customize-columns-no-results">
            No matches
          </div>
        </ng-container>

        <div class="customize-columns-group-divider"></div>
      </div>
    </div>

    <div class="customize-columns-footer">
      <div class="customize-columns-footer-actions">
        <a
          (click)="cancel()"
          id="customize-columns-cancel"
          data-testid="customize-columns-cancel"
          class="link-button align-self-center"
        >
          Cancel
        </a>
        <span
          nz-tooltip
          [nzTooltipTitle]="saveDisabled ? 'Select at least one column to display it in the table' : ''"
        >
          <button
            nz-button
            nzType="primary"
            class="primary-button"
            [disabled]="saveDisabled"
            (click)="save()"
            id="customize-columns-save"
            data-testid="customize-columns-save"
            type="button"
          >
            Save
          </button>
        </span>
      </div>
    </div>
  </ng-container>
</nz-drawer>
